import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function missingProductsReducer(state = initialState.csvImportmissingIvms, action) {
	//avoiding state mutation, while updating nested states.
	switch (action.type) {
		case types.CSV_IMPORT_MISSING_IVMS:
			return action.data;
		default:
			return state;
	}
}
